import { Component, forwardRef } from '@angular/core';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { User, UserPreference, PreferenceCategories, PreferenceDisplay} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';

@Component({
  selector: 'cw-ci-profile-preferences',
  templateUrl: './profile-preferences.component.html',
  styleUrls: ['./profile-preferences.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => ProfilePreferencesComponent)}]
})
export class ProfilePreferencesComponent extends WizardScreenComponent {

  preferences: UserPreference[] = [];

  constructor(private _sessionService: SessionService, private _apiService: PlatformApiService) {
    super();

    this.form = new FormGroup({});

    for (const pref of this._sessionService.getCurrentUser().preferences) {
      const ctrl1 = new FormControl({disabled: true}, [Validators.required]);
      this.form.registerControl(`${pref.key}.value`, ctrl1);
      const ctrl2 = new FormControl();
      this.form.registerControl(`${pref.key}.useDefault`, ctrl2);
    }
  }

  onLoad() {
    console.log('loading');
    this.form.reset();
    this.showSpinner()

    this._apiService.getAccountUser(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id).subscribe(
      usr=> {
        for (const pref of usr.preferences) {

          const valCtrl = this.form.controls[`${pref.key}.value`];
          const defCtrl = this.form.controls[`${pref.key}.useDefault`];

          valCtrl.setValue(pref.value);
          if (pref.value == undefined) {
            valCtrl.disable();
            valCtrl.setValue(pref.defaultValue);
            defCtrl.setValue(true);
          } else {
            valCtrl.enable();
            valCtrl.setValue(pref.value);
            defCtrl.setValue(false);
          }
        }

        this.preferences = this._sessionService.getCurrentUser().preferences;
        console.log(this.preferences);

        this.hideSpinner()
        super.onLoad();
      }
    );
  }

  updatePreferenceEnabled(chckbox, prefKey) {
    if (chckbox.checked) {
      const pref = this.preferences.find(el => el.key == prefKey);
      this.form.controls[prefKey + '.value'].disable();
      this.form.controls[prefKey + '.value'].setValue(pref.defaultValue);
    } else {
      this.form.controls[prefKey + '.value'].enable();
    }
  }

  onSave() {
    if (this.isValid()) {
      this.showSpinner('Saving...');

      const payload = [];

      for (const pref of this.preferences) {
        if (!this.form.controls[`${pref.key}.useDefault`].value) {
          payload.push({
            preferenceId: pref.preferenceId,
            key: pref.key,
            value: this.form.controls[`${pref.key}.value`].value
          })
        }
      }

      this._apiService.setUserPreferences(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id, {preferences: payload}).subscribe((newPrefs) => {
        this.hideSpinner()
        this._sessionService.updateCurrentUserPreferences(newPrefs);
        super.onSave();
      }, err => {
        // TODO emit error message
        console.log('Failed to save user preferences', err);
        this.hideSpinner()
      })
    }
  }

  getPreferenceCategories() {
    return PreferenceCategories;
  }

  getPreferencesByCategory(category) {
    return this.preferences.filter((pref) => {
      const prefDisplay = PreferenceDisplay.find(el => el.key == pref.key && el.category == category);
      return (prefDisplay != undefined);
    });
  }

  getPreferenceLabel(pref) {
    const prefDisplay = PreferenceDisplay.find(el => el.key == pref.key);
    if (prefDisplay) {
      return prefDisplay.label;
    } else {
      return pref.key;
    }
  }
}
